export enum GenericLabelColor {
  Primary = 'primary',
  Secondary = 'secondary',
  Error = 'error',
  Success = 'success',
  Warning = 'warning',
  Gray = 'gray',
  White = 'white',
  Black = 'black',
  Turquoise = 'turquoise'
}

export enum GenericLabelSize {
  Small = 'small',
  Medium = 'medium',
  Large = 'large'
}
